var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "div",
        {
          staticClass: "flex-column align-items-end height32",
          class: { "show-select-only": _vm.showTabs },
        },
        [
          _vm.showTabs
            ? _c(
                "yxt-select",
                {
                  attrs: {
                    size: "small",
                    placeholder: _vm.$t("pc_gwnl_global_pleaseSelect"),
                  },
                  on: { change: _vm.selectedCatalogHandler },
                  model: {
                    value: _vm.selectedCatalogId,
                    callback: function ($$v) {
                      _vm.selectedCatalogId = $$v
                    },
                    expression: "selectedCatalogId",
                  },
                },
                _vm._l(_vm.catalogList, function (catalogs) {
                  return _c("yxt-option", {
                    key: catalogs.id,
                    attrs: {
                      disabled: catalogs.disabled,
                      label: catalogs.name,
                      value: catalogs.id,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.noRight
        ? _c("yxtf-scrollbar", [
            _c(
              "div",
              {
                staticClass: "gwnl-web-position-skills-right-content mt32 pt24",
              },
              [
                _vm.disadvList && _vm.disadvList.length > 0
                  ? _c("right-item", {
                      attrs: {
                        detail: _vm.disadvList,
                        "tag-style": !_vm.skillWithLevel,
                        type: 2,
                        legends: _vm.legends,
                      },
                    })
                  : _vm._e(),
                _vm.advList && _vm.advList.length > 0
                  ? _c("right-item", {
                      attrs: {
                        detail: _vm.advList,
                        "tag-style": !_vm.skillWithLevel,
                        type: 1,
                        legends: _vm.legends,
                      },
                    })
                  : _vm._e(),
                _vm.disadvList &&
                _vm.disadvList.length === 0 &&
                _vm.advList &&
                _vm.advList.length === 0
                  ? _c("yxtf-empty", { staticClass: "mb47" })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }